export default __webpack_public_path__ + "./static/icon512_maskable.png";